const ErrorPage = ({errorMessage}) => {
    return (
        <div>
            {errorMessage}
        </div>
    );
};

export default ErrorPage;